export default "__VITE_ASSET__BDX3n2FC__"